export default {
  message: {
    HM: '海贸',
    YK: '优科',
    KY: '康毅',
    LR: '凌仁',
    FH: '方禾',
    YM: '优铭',
    DJ: '东捷',
    SS: '三甚',
    YB: '裕百',
    DSW: '达升威',
    QJ: '千景',
    
    海贸: 'HM',
    优科: 'YK',
    康毅: 'KY',
    凌仁: 'LR',
    方禾: 'FH',
    优铭: 'YM',
    东捷: 'DJ',
    三甚: 'SS',
    裕百: 'YB',
    达升威: 'DSW',
    千景: 'QJ',

    // haimao: 'HM',
    // youke: 'YK',
    // kangyi: 'KY',
    // lingren: 'LR',
    // fanghe: 'FH',
    // youming: 'YM',
  },
}